export default __webpack_public_path__ + "static/media/ic_enter_search.2a71e4da.svg";